<template>
  <header id="header">
    <img class="logo" src="/portals/home/FFR/images/logo.png">
    <h1 style="display: inline-block;"> FasFreeRoute</h1>
    <p v-if="viewMode == 'main'">VoIP Testing Tools for all your routes.<br/>
      Powered By <a class="mrt-primary-color" href="https://jikatel.com">Jikatel</a> for satisfying customers.</p>

    <p v-if="viewMode == 'signup'">Sign Up - Please fill the following Fields</p>

    <p v-if="viewMode == 'signin'">Sign In - Please use your credentials</p>
  </header>
</template>

<script>
export default {
  props : {
    viewMode: {
      required: false,
      default: 'main'
    }
  }
}
</script>

<style scoped>
.logo {
  position: relative;
  display: inline-block;
  width: 160px;
  margin-left: -10px;
  margin-right: 20px;
  top: 30px;
}
</style>
